import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import Widget from '~/src/components/Widget';

export const PackageDesc = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextSecondary};
    display: -webkit-box;
    display: -moz-box;
    display: box;
    -webkit-box-orient: vertical;
    --moz-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
`;

export const WidgetPrice = styled(Widget.Price)<{ isPromoPrice: boolean }>`
    color: ${({ isPromoPrice }) => isPromoPrice ? COLORS.LabelsText_2 : COLORS.TextSecondary};
`;

export const WidgetKebab = styled(Widget.Kebab)`
    div[data-name='popup-menu'] {
        top: calc(-100% - 16px);
        right: 0;
        z-index: 1;
        min-width: fit-content;
    }
`;

export const IncludesPopup = styled(DefaultPopup)`
    width: 600px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    min-height: auto;
`;

export const PopupButtonBlock = styled.div`
    flex-direction: row;
    margin-top: 16px;
    gap: 12px;
       
    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
    }
`;

export const PopupInner = styled.div`
    padding: 32px;
    flex-direction: column;
`;

export const PopupTitle = styled.div`
    ${FONTS.H3}
    margin-bottom: 8px;
    max-width: 480px;
`;

export const PopupDescription = styled.div`
    ${FONTS.S}
    display: block;
    & ul li{
        background-image: url('/static/images/tariff-lines/list-style.png');
        background-repeat: no-repeat;
        padding-left: 45px;
        min-height: 40px;
        margin-bottom: 8px;
        line-height: 40px;
    }
    
    & ol {
        list-style: auto;
        padding-left: 20px;
    }
`;

export const Text = styled.p`
    ${FONTS.M};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        ${FONTS.S};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.M};
    }
`;
